import { useTranslation } from 'react-i18next';
import { Smartphone } from 'lucide-react';
import { getInviteTitleTier } from 'Containers/Clients/utils/inviteJourney';
import styles from './InviteJourneyCard.module.scss';

const TIER_TITLE_KEYS = {
  start: 'titleStart',
  community: 'titleCommunity',
  group: 'titleGroup',
  app: 'titleApp',
};

// Solo progresso: la scelta dei contatti (rubrica) è disponibile solo dall'app ZetaBarber Business.
const InviteJourneyCard = ({ journey }) => {
  const { t } = useTranslation();

  const stage = journey?.current;
  const done = Boolean(journey?.done);
  if (!stage && !done) return null;
  if (!journey?.stages?.length) return null;

  const baseline = Math.max(0, Number(journey.baseline) || 0);
  const spent = Math.max(0, Number(journey.spent) || 0);
  const titleKey = done
    ? 'titleDone'
    : TIER_TITLE_KEYS[getInviteTitleTier(spent, baseline)] || 'titleStart';
  const barPct = done ? 100 : baseline ? Math.round((Math.min(spent, baseline) / baseline) * 100) : 0;

  return (
    <div className={styles.root}>
      <div className={styles.card}>
        <div className={styles.text}>
          <span className={styles.title}>{t(`clients.list.invite.${titleKey}`)}</span>
          <span className={styles.body}>{t('clients.list.invite.body')}</span>
        </div>
        <div className={styles.side}>
          <div className={styles.progress}>
            <span className={styles.meta}>
              <span>{t('clients.list.invite.progress', { current: spent, total: baseline })}</span>
              <span className={styles.percent}>{barPct}%</span>
            </span>
            <span className={styles.track}>
              <span className={styles.fill} style={{ width: `${barPct}%` }} />
            </span>
          </div>
          {!done ? (
            <span className={styles.appHint}>
              <Smartphone size={16} strokeWidth={2.2} aria-hidden />
              <span>{t('clients.list.invite.openInApp')}</span>
            </span>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default InviteJourneyCard;
